<template>
    <div class="troop-box">
        <img class="m-0-a troop-title" :src="info.troop_title" alt="">
        <div class="m-0-a t-a-c troop-type-box" :style="{backgroundImage: 'url(' + info.troop_type.bg + ')' }">
            <a :class="['d-i-b','troop-type',troopIndex==index?'troop-active':'']" v-for="(item,index) in info.troop_type.text" :key="index" @click="changeTroop(index)">{{item}}</a>
        </div>
        <div class="troop-type-img m-0-a">
            <img class="d-i-b" :src="info.troop_type.img[troopIndex]" alt="">
        </div>
    </div>
</template>

<style lang="less" scoped>
    .troop-box {
        margin-top: 1.066667rem;
    }
    .troop-title {
        margin-top: .053333rem;
        width: 6.666667rem;
        height: .826667rem;
    }
    .troop-type-box {
        width: 10rem;
        height: 1.226667rem;
        background-size: 100% 100%;
        margin: .373333rem auto;
        .troop-type {
            width: 25%;
            font-size: .4rem;
            line-height: 1.226667rem;
            color: #332B17;
            cursor: pointer;
        }
        .troop-active {
            color: #fff;
        }
    }
    .troop-type-img {
        width: 9.6rem;
    }
</style>

<script>
    export default {
        props: ['info'],
        data() {
            return {
                troopIndex: 0
            }
        },
        created() {
            // console.log(this.info)
        },
        methods: {
            changeTroop(index) {
                // console.log(index)
                this.troopIndex = index
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/smsgz/components/hero/troop-tab.vue